import { Injectable, Injector } from '@angular/core';
import { HttpHandler, HttpEvent, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { catchError, switchMap, filter, take } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(private injector: Injector) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let auth = this.injector.get(AuthService);
        let token = auth.isLoggedIn() ? auth.getLoggedInUser()!.TokenResponse!.Token : null;
        if (token) {
            request = this.addToken(request, token);
        }

        return next.handle(request).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    return this.handle401Error(request, next);
                } else {
                    return throwError(() => error);
                }
            }),
        );
    }

    private addToken(request: HttpRequest<any>, token: string) {
        return request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
        });
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            let auth = this.injector.get(AuthService);
            auth.setAuth(null);

            return auth.refreshToken().pipe(
                switchMap((res: any) => {
                    if (res) {
                        let tokenResponse = auth.getLoggedInUser()!.TokenResponse;
                        this.isRefreshing = false;
                        //if (tokenResponse.RefreshToken) {
                        this.refreshTokenSubject.next(tokenResponse.Token);
                        return next.handle(this.addToken(request, tokenResponse.Token));
                        //}
                        //else {
                        //    auth.logout();
                        //    return throwError(res);
                        //}
                    } else {
                        this.isRefreshing = false;
                        return throwError(() => res);
                    }
                }),
            );
        } else {
            return this.refreshTokenSubject.pipe(
                filter(token => token != null),
                take(1),
                switchMap(jwt => {
                    return next.handle(this.addToken(request, jwt));
                }),
            );
        }
    }
}
